// import React from "react";
// import CaseUnit from "./caseUnit";
// import Progress from "./progress";
// import TypeUnit from "./typeUnit";
// import BookingDate from "./BookingDate";
// import { useTabsFilter } from "../../../context/TabsFilterContext"; // ← إمبورت جديد
// import ar from "../../../lang/ar";
// import en from "../../../lang/en";
// function Tabs({ lang }) {
//   const { activeTab, setActiveTab } = useTabsFilter();
//   const handleTypeClick = () => {
//     setActiveTab("type");
//   };
//   const handleAvailabilityClick = () => {
//     setActiveTab("availability");
//   };
//   const handleConstructionClick = () => {
//     setActiveTab("construction");
//   };
//   const handleBookingDateClick = () => {
//     setActiveTab("bookingDate");
//   };
//   const translations = lang === "ar" ? ar : en;
//   return (
//     <>
//       <p className="filter-header p-0">
//         {lang === "ar" ? "تصفية الوحدات" : "Unit Filter"}
//       </p>
//       <div className="filter-type">
//         <button
//           type="button"
//           className={`btn m-0 p-0 ${
//             activeTab === "type" ? "type-active active" : ""
//           }`}
//           onClick={handleTypeClick}
//         >
//           {lang === "ar" ? "النوع" : "Type"}
//         </button>
//         <button
//           type="button"
//           className={`btn m-0 p-0 ${
//             activeTab === "availability" ? "type-active active" : ""
//           }`}
//           onClick={handleAvailabilityClick}
//         >
//           {lang === "ar" ? "التوافر" : "Availability"}
//         </button>
//         <button
//           type="button"
//           className={`btn m-0 p-0 ${
//             activeTab === "construction" ? "type-active active" : ""
//           }`}
//           onClick={handleConstructionClick}
//         >
//           {lang === "ar" ? "التقدم" : "Progress"}
//         </button>
//         <button
//           type="button"
//           className={`btn m-0 p-0 ${
//             activeTab === "bookingDate" ? "type-active active" : ""
//           }`}
//           onClick={handleBookingDateClick}
//         >
//           {lang === "ar" ? "تاريخ الحجز" : "Booking Date"}
//         </button>
//       </div>
//       {activeTab === "availability" && <CaseUnit lang={lang} />}
//       {activeTab === "bookingDate" && <BookingDate lang={lang} />}
//       {(activeTab === "type" ||
//         activeTab === "availability" ||
//         activeTab === "construction" ||
//         activeTab === "bookingDate") && <TypeUnit lang={lang} />}
//       {activeTab === "construction" && <Progress lang={lang} />}
//     </>
//   );
// }

// export default Tabs;





















import React, { useState } from "react";
import CaseUnit from "./caseUnit";
import Progress from "./progress";
import TypeUnit from "./typeUnit";
import BookingDate from "./BookingDate";
import { useTabsFilter } from "../../../context/TabsFilterContext";
// import ar from "../../../lang/ar";
// import en from "../../../lang/en";

function Tabs({ lang }) {
  const { activeTab, setActiveTab } = useTabsFilter();
    const [activeDropdown, setActiveDropdown] = useState(null); 
  const toggleDropdown = (name) => {
    setActiveDropdown(prev => (prev === name ? null : name));
  };

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  return (
    <>
      <p className="filter-header p-0">
        {lang === "ar" ? "تصفية الوحدات" : "Unit Filter"}
      </p>
      
      <div className="filter-type">
        <button
          type="button"
          className={`btn m-0 p-0 ${activeTab === "type" ? "type-active active" : ""}`}
          onClick={() => handleTabClick("type")}
        >
          {lang === "ar" ? "النوع" : "Type"}
        </button>
        <button
          type="button"
          className={`btn m-0 p-0 ${activeTab === "availability" ? "type-active active" : ""}`}
          onClick={() => handleTabClick("availability")}
        >
          {lang === "ar" ? "التوافر" : "Availability"}
        </button>
        <button
          type="button"
          className={`btn m-0 p-0 ${activeTab === "construction" ? "type-active active" : ""}`}
          onClick={() => handleTabClick("construction")}
        >
          {lang === "ar" ? "التقدم" : "Progress"}
        </button>
        <button
          type="button"
          className={`btn m-0 p-0 ${activeTab === "bookingDate" ? "type-active active" : ""}`}
          onClick={() => handleTabClick("bookingDate")}
        >
          {lang === "ar" ? "تاريخ الحجز" : "Booking Date"}
        </button>
      </div>

      <div className="filter-content-area col-12">
        {/* Availability */}
        {activeTab === "availability" && (
          <CaseUnit 
            lang={lang} 
            isOpen={activeDropdown === "availability"} 
            toggleOpen={() => toggleDropdown("availability")} 
          />
        )}

        {/* Booking Date */}
        {activeTab === "bookingDate" && (
          <BookingDate 
            lang={lang} 
            isOpen={activeDropdown === "bookingDate"} 
            toggleOpen={() => toggleDropdown("bookingDate")} 
          />
        )}

        {/* Type (يظهر دائماً لكن الدروب داون محكوم بـ activeDropdown) */}
        <TypeUnit 
          lang={lang} 
          isOpen={activeDropdown === "type"} 
          toggleOpen={() => toggleDropdown("type")} 
        />

        {/* Progress */}
        {activeTab === "construction" && (
          <Progress 
            lang={lang} 
            isOpen={activeDropdown === "construction"} 
            toggleOpen={() => toggleDropdown("construction")} 
          />
        )}
      </div>
    </>
  );
}

export default Tabs;